import React from "react";
import Message from "../app/Message";
import "../../assets/styles/cards.css";

export default class CardMessage extends React.Component {
  render() {
    return (
      <div className="offline-message-wrapper">
        <div className="not-allowed  bg-nl color-n f6">
          <div className="space card-bottom-msg color-n">
            <Message message={this.props.retrievalMessage} role="alert" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/card/CardMessage.jsx